import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appFilterHost]',
  standalone: false,
})
export class FilterHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
